import { MainRoutes } from '@app/app.model';

/**
 * Rotte di autenticazione a tutto schermo: bloccano la navigazione verso altri moduli.
 * In queste pagine navbar e footer non vanno mostrati, nemmeno fuori dalla modalità embedded.
 */
export const FULLSCREEN_AUTH_ROUTES: readonly MainRoutes[] = ['reset-password'];

/**
 * Indica se l'URL corrente è una rotta di autenticazione a tutto schermo, in cui l'utente
 * non deve poter raggiungere altri moduli del sistema.
 *
 * @param url URL completo (può contenere parametri di query, frammento e outlet ausiliari)
 */
export const isFullscreenAuthRoute = (url: string): boolean => {
  const firstSegment = url.split(/[?#]/)[0].replace(/^\/+/, '').split('/')[0].split('(')[0];
  return FULLSCREEN_AUTH_ROUTES.includes(firstSegment as MainRoutes);
};
